module.exports = __webpack_public_path__ + "assets/paypal-logo.5f1b5ff2.svg";